import React, { FC, useState, useEffect } from 'react';
import { useStyles } from './styles';
import { Search } from 'components/Search';
import { BaseNavigation } from 'components/BaseNavigation';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import { Button, Grid } from '@material-ui/core';
import { ActionItem } from '../DepartmentsHeader/types';
import { TableItems, Provider } from './types';
import { InvitationForm } from 'components/Tables';
import { InvitationNewPassword } from 'components/Forms/InvitationForm/InvitationNewPassword';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Box,
  IconButton,
  Checkbox,
  ListItemText,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router-dom';
import { handleCompanyUrl } from 'utils/organizationUtils';
import GoogleIcon from '@mui/icons-material/Google';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import { GitHub } from '@mui/icons-material';
import { useAppPreloader } from 'hooks/useAppPreloader';
import BusinessIcon from '@mui/icons-material/Business';
import ListItemIcon from '@mui/material/ListItemIcon';
import LayersIcon from '@material-ui/icons/Layers';
const TableHeader: FC<TableItems> = ({
  headerLabel,
  headerAction,
  headerChecked,
  headerIcon,
  searchAction,
  hanleClicked,
  usersAction,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    AppStore: { providerList },
    userStore: { updateEndUserProfileInfo },
    ldapStore: { getGroupsAndDepartmentsForSelfRegister, departmentView, groupView },
    notificationStore: { openNotification },
  } = useStore();
  const [openAdd, setOpenAdd] = useState(false);
  const [openInvitationModal, setOpenInvitationModal] = useState<boolean>(false);
  const [openPasswordModal, setOpenPasswordModal] = useState<boolean>(false);
  const [openDepartmentRequest, setOpenDepartmentRequest] = useState<boolean>(false);
  const [openGroupRequest, setOpenGroupRequest] = useState<boolean>(false);
  const [departmentName, setDepartmentName] = useState<string>('');
  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const getGroupsAndDepartmentsReq = useQuery(
    'getGroupsAndDepartmentsReq',
    () => getGroupsAndDepartmentsForSelfRegister(),
    {
      enabled: openDepartmentRequest || openGroupRequest,
      onError: () => openNotification('error', `Can't get departments and groups`),
    }
  );
  const handleClickAdd = () => {
    hanleClicked();
    setOpenAdd((prev) => !prev);
  };

  const handleClicked = () => {
    if (headerLabel === 'Departments') {
      setOpenDepartmentRequest(true);
    } else if (headerLabel === 'Add New Group') {
      setOpenGroupRequest(true);
    }
  };
  const [showConnectedButton, setShowConnectedButton] = useState<string | null>(null);
  const [showConnectedStatus, setShowConnectedStatus] = useState<string | null>(null);
  const [showZoomButton, setShowZoomButton] = useState<string | null>(null);
  const [showZoomStatus, setShowZoomStatus] = useState<string | null>(null);
  const [showMicrosoftButton, setShowMicrosoftButton] = useState<string | null>(null);
  const [showMicrosoftStatus, setShowMicrosoftStatus] = useState<string | null>(null);
  const [showGithubButton, setShowGithubButton] = useState<string | null>(null);
  const [showGithubStatus, setShowGithubStatus] = useState<string | null>(null);
  // Clear any corrupted localStorage data
  useEffect(() => {
    try {
      const profileData = localStorage.getItem('Profile');
      if (profileData && profileData === 'undefined') {
        localStorage.removeItem('Profile');
      }
    } catch (error) {
      localStorage.removeItem('Profile');
    }
  }, []);

  let profile = null;
  try {
    const profileData = localStorage.getItem('Profile');
    profile = profileData && profileData !== 'undefined' ? JSON.parse(profileData) : null;
  } catch (error) {
    console.error('Error parsing profile from localStorage:', error);
    localStorage.removeItem('Profile');
    profile = null;
  }
  const handleClickAwayAdd = () => {
    setOpenAdd(false);
  };

  const providerListReq = useQuery('providerListReq', () => providerList(), {
    enabled: profile?.permission !== 'EndUser' && profile?.permission !== 'Manager' && openAdd,
    onError: () => openNotification('error', `We are unable to connect `),
  });
  useEffect(() => {
    if (providerListReq.data) {
      const providers: Provider[] = providerListReq.data;
      let googleProvider: Provider | undefined;
      let zoomProvider: Provider | undefined;
      let microsoftProvider: Provider | undefined;
      let githubProvider: Provider | undefined;
      providers.forEach((provider) => {
        if (provider.provider === 'google') {
          googleProvider = provider;
        } else if (provider.provider === 'zoom') {
          zoomProvider = provider;
        } else if (provider.provider === 'microsoft') {
          microsoftProvider = provider;
        } else if (provider.provider === 'github') {
          githubProvider = provider;
        }
      });
      if (googleProvider) {
        setShowConnectedButton(googleProvider.token || null);
        setShowConnectedStatus(googleProvider.tokenStatus || null);
      } else {
        setShowConnectedButton(null);
        setShowConnectedStatus(null);
      }
      if (zoomProvider) {
        setShowZoomButton(zoomProvider.token || null);
        setShowZoomStatus(zoomProvider.tokenStatus || null);
      } else {
        setShowZoomButton(null);
        setShowZoomStatus(null);
      }
      if (microsoftProvider) {
        setShowMicrosoftButton(microsoftProvider.token || null);
        setShowMicrosoftStatus(microsoftProvider.tokenStatus || null);
      } else {
        setShowMicrosoftButton(null);
        setShowMicrosoftStatus(null);
      }
      if (githubProvider) {
        setShowGithubButton(githubProvider.token || null);
        setShowGithubStatus(githubProvider.tokenStatus || null);
      } else {
        setShowGithubButton(null);
        setShowGithubStatus(null);
      }
    } else {
      setShowConnectedButton(null);
      setShowConnectedStatus(null);
      setShowZoomButton(null);
      setShowZoomStatus(null);
      setShowMicrosoftButton(null);
      setShowMicrosoftStatus(null);
      setShowGithubButton(null);
      setShowGithubStatus(null);
    }
  }, [providerListReq.data]);

  const handleClickPassword = () => {
    setOpenPasswordModal(true);
  };

  const handleClick = () => {
    if (headerLabel === 'User') {
      history.push(handleCompanyUrl('/apps/google?value=two'));
    } else if (headerLabel === 'Add New Group') {
      history.push(handleCompanyUrl('/apps/google?value=three'));
    } else if (headerLabel === 'Departments') {
      history.push(handleCompanyUrl('/apps/google?value=four'));
    }
  };

  const handleZoom = () => {
    if (headerLabel === 'User') {
      history.push(handleCompanyUrl('/apps/zoom?value=two'));
    } else if (headerLabel === 'Add New Group') {
      history.push(handleCompanyUrl('/apps/zoom?value=three'));
    }
  };

  const handleMicrosoft = () => {
    if (headerLabel === 'User') {
      history.push(handleCompanyUrl('/apps/microsoft?value=two'));
    } else if (headerLabel === 'Add New Group') {
      history.push(handleCompanyUrl('/apps/microsoft?value=three'));
    }
  };

  const handleGithub = () => {
    if (headerLabel === 'User') {
      history.push(handleCompanyUrl('/apps/github?value=two'));
    }
  };
  const handleClose = () => {
    setOpenInvitationModal(false);
  };
  const handleClosePassword = () => {
    setOpenPasswordModal(false);
  };

  const handleDepartmentRequestSubmit = async () => {
    if (departmentName.trim()) {
      try {
        await updateEndUserProfileInfo({ department_name: departmentName });
        openNotification('success', `Department access request for "${departmentName}" has been submitted to admin`);
        setDepartmentName('');
        setOpenDepartmentRequest(false);
      } catch (error) {
        openNotification('error', 'Failed to submit department request');
      }
    }
  };

  const handleGroupRequestSubmit = async () => {
    if (selectedGroups.length > 0) {
      try {
        const groupData: any = {};
        selectedGroups.forEach((group, index) => {
          groupData[`group_names[${index}]`] = group;
        });
        await updateEndUserProfileInfo(groupData);
        openNotification(
          'success',
          `Group access request for ${selectedGroups.length} group(s) has been submitted to admin`
        );
        setSelectedGroups([]);
        setOpenGroupRequest(false);
      } catch (error) {
        openNotification('error', 'Failed to submit group request');
      }
    }
  };

  const handleCloseDepartmentRequest = () => {
    setDepartmentName('');
    setOpenDepartmentRequest(false);
  };

  const handleCloseGroupRequest = () => {
    setSelectedGroups([]);
    setOpenGroupRequest(false);
  };
  const mockCreateActions: ActionItem[] = [
    {
      label: headerLabel,
      icon: headerIcon,
      checked: headerChecked,
      action: headerAction,
    },
  ];

  const menuProps = {
    getContentAnchorEl: null as any,
    anchorOrigin: {
      vertical: 'bottom' as const,
      horizontal: 'left' as const,
    },
    transformOrigin: {
      vertical: 'top' as const,
      horizontal: 'left' as const,
    },
    disablePortal: true,
    PaperProps: {
      style: {
        maxHeight: 200,
      },
    },
    MenuListProps: {
      style: {
        cursor: 'pointer',
      },
    },
  };

  useAppPreloader(providerListReq.isLoading);
  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <BaseNavigation type={headerLabel} />
        </Grid>

        <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
          <Search handelSearch={searchAction} />

          {usersAction === true && (
            <div className={classes.root}>
              <Button
                onClick={handleClickPassword}
                variant='contained'
                // color='primary'
                className={classes.btnAdd}
              >
                Invite
              </Button>
            </div>
          )}
          <ClickAwayListener onClickAway={handleClickAwayAdd}>
            <div className={classes.root}>
              {profile?.permission !== 'EndUser' && profile?.permission !== 'Manager' ? (
                <Button
                  variant='contained'
                  // color='primary'
                  onClick={handleClickAdd}
                  className={classes.btnAdd}
                >
                  <ControlPointIcon />
                </Button>
              ) : (
                <Button
                  variant='contained'
                  // color='primary'
                  onClick={handleClicked}
                  className={classes.btnAdd}
                >
                  <ControlPointIcon />
                </Button>
              )}
              {openAdd ? (
                <div className={classes.dropdown}>
                  {mockCreateActions.map((item, index) => (
                    <MenuItem key={index} value={item.label} className={classes.selectItem} onClick={item.action}>
                      {item.icon} {item.label}
                    </MenuItem>
                  ))}
                  {showConnectedButton &&
                    showConnectedStatus === 'active' &&
                    (headerLabel === 'User' || headerLabel === 'Add New Group' || headerLabel === 'Departments') && (
                      <MenuItem key={1} value='item' className={classes.selectItem} onClick={handleClick}>
                        <GoogleIcon
                          style={{
                            color: 'grey',
                          }}
                        />
                        Import from Google
                      </MenuItem>
                    )}
                  {showZoomButton &&
                    showZoomStatus === 'active' &&
                    (headerLabel === 'User' || headerLabel === 'Add New Group') && (
                      <MenuItem key={2} value='item' className={classes.selectItem} onClick={handleZoom}>
                        <VideoCameraBackIcon
                          style={{
                            color: 'grey',
                          }}
                        />
                        Import from Zoom
                      </MenuItem>
                    )}
                  {showMicrosoftButton &&
                    showMicrosoftStatus === 'active' &&
                    (headerLabel === 'User' || headerLabel === 'Add New Group') && (
                      <MenuItem key={3} value='item' className={classes.selectItem} onClick={handleMicrosoft}>
                        <MicrosoftIcon
                          style={{
                            color: 'grey',
                          }}
                        />
                        Import from Microsoft
                      </MenuItem>
                    )}
                  {showGithubButton && showGithubStatus === 'active' && headerLabel === 'User' && (
                    <MenuItem key={4} value='item' className={classes.selectItem} onClick={handleGithub}>
                      <GitHub
                        style={{
                          color: 'grey',
                        }}
                      />
                      Import from Github
                    </MenuItem>
                  )}
                </div>
              ) : null}
            </div>
          </ClickAwayListener>
        </Grid>
      </Grid>

      {usersAction === true && (
        <>
          <InvitationForm
            emailtemps={() => {
              ('');
            }}
            step={() => {
              ('');
            }}
            open={openInvitationModal}
            refetch={() => {
              ('');
            }}
            handleClose={handleClose}
          />
          <InvitationNewPassword
            emailtemps={() => {
              ('');
            }}
            step={() => {
              ('');
            }}
            open={openPasswordModal}
            refetch={() => {
              ('');
            }}
            handleClose={handleClosePassword}
          />
        </>
      )}
      <Dialog open={openDepartmentRequest} onClose={handleCloseDepartmentRequest} maxWidth='sm' fullWidth>
        <DialogTitle style={{ padding: '16px', fontSize: 18, fontWeight: 600 }}>
          <BusinessIcon fontSize='small' /> Request Department Access
          <IconButton
            onClick={handleCloseDepartmentRequest}
            style={{
              position: 'absolute',
              right: 10,
              top: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent style={{ padding: '8px 16px 16px' }}>
          <FormControl fullWidth size='small' style={{ marginTop: 8 }}>
            <InputLabel>Select Department</InputLabel>

            <Select
              value={departmentName}
              onChange={(e) => setDepartmentName(e.target.value as string)}
              label='Select Department'
              MenuProps={menuProps} // 🔥 FIX APPLIED
            >
              {departmentView?.map((dept: any) => (
                <MenuItem key={dept.dn} value={dept.ou || dept.cn} style={{ cursor: 'pointer' }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <BusinessIcon fontSize='small' />
                  </ListItemIcon>
                  {dept.ou || dept.cn}
                </MenuItem>
              ))}

              {getGroupsAndDepartmentsReq.data?.departments?.map((dept: any) => (
                <MenuItem key={dept.dn} value={dept.ou || dept.cn} style={{ cursor: 'pointer' }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <BusinessIcon fontSize='small' />
                  </ListItemIcon>
                  {dept.ou || dept.cn}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
          <Button
            onClick={handleDepartmentRequestSubmit}
            variant='contained'
            color='primary'
            disabled={!departmentName || !departmentName.trim()}
            style={{
              width: 180,
              height: 36,
              textTransform: 'none',
            }}
          >
            Submit Request
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openGroupRequest} onClose={handleCloseGroupRequest} maxWidth='sm' fullWidth>
        <DialogTitle style={{ padding: '16px', fontSize: 18, fontWeight: 600 }}>
          <LayersIcon fontSize='small' /> Request Group Access
          {/* <img src={logoImage} alt={logoImage !== undefined ? 'No Image' : 'Image'} style={{width:'80px'}} />Request Group Access */}
          <IconButton
            onClick={handleCloseGroupRequest}
            style={{
              position: 'absolute',
              right: 10,
              top: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent style={{ padding: '8px 16px 16px' }}>
          <FormControl fullWidth style={{ marginTop: 8 }}>
            <InputLabel style={{ fontSize: 18, marginBottom: '20px' }}>Select Groups</InputLabel>

            <Select
              multiple
              value={selectedGroups}
              onChange={(e) => setSelectedGroups(e.target.value as string[])}
              label='Select Groups'
              MenuProps={menuProps} // 🔥 FIX APPLIED
              renderValue={(selected) => (
                <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {(selected as string[]).map((value) => (
                    <Chip
                      key={value}
                      icon={<LayersIcon fontSize='small' />}
                      label={value}
                      style={{
                        fontSize: 18,
                        height: 32,
                      }}
                    />
                  ))}
                </Box>
              )}
            >
              {groupView?.map((group: any) => (
                // <MenuItem
                //   key={group.dn}
                //   value={group.cn}
                //   style={{ cursor: 'pointer' }}
                // >
                //   <Checkbox
                //     checked={selectedGroups.indexOf(group.cn) > -1}
                //     size="small"
                //     style={{ cursor: 'pointer' }}
                //   />
                //   <ListItemText
                //     primary={group.cn}
                //     primaryTypographyProps={{ style: { fontSize: 18, cursor: 'pointer' } }}
                //   />
                // </MenuItem>

                <MenuItem
                  key={group.dn}
                  value={group.cn}
                  //  style={{ cursor: 'pointer' }}
                >
                  <Checkbox checked={selectedGroups.indexOf(group.cn) > -1} size='small' />

                  {/* <ListItemIcon sx={{ minWidth: 36 }}>
                    <LayersIcon fontSize="small" />
                  </ListItemIcon> */}

                  <ListItemText
                    primary={group.cn}
                    primaryTypographyProps={{ style: { fontSize: 18, cursor: 'pointer' } }}
                  />
                </MenuItem>
              ))}

              {getGroupsAndDepartmentsReq.data?.groups?.map((group: any) => (
                <MenuItem
                  key={group.dn}
                  value={group.cn}
                  // style={{ cursor: 'pointer' }}
                >
                  <Checkbox
                    checked={selectedGroups.indexOf(group.cn) > -1}
                    size='small'
                    // style={{ cursor: 'pointer' }}
                  />
                  {/* <ListItemIcon sx={{ minWidth: 36 }}>
                    <LayersIcon fontSize="small" />
                  </ListItemIcon> */}
                  <ListItemText
                    primary={group.cn}
                    primaryTypographyProps={{ style: { fontSize: 18, cursor: 'pointer' } }}
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
          <Button
            onClick={handleGroupRequestSubmit}
            variant='contained'
            color='primary'
            disabled={selectedGroups.length === 0}
            style={{
              width: 180,
              height: 36,
              textTransform: 'none',
            }}
          >
            Submit Request
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TableHeader;
